import { render } from "./CustomizeEvent.vue?vue&type=template&id=5eacea2f"
import script from "./CustomizeEvent.vue?vue&type=script&lang=js"
export * from "./CustomizeEvent.vue?vue&type=script&lang=js"

import "./CustomizeEvent.vue?vue&type=style&index=0&id=5eacea2f&lang=scss&scope=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__